module.exports = "## App Bar\n\nThe [app bar](https://www.google.com/design/spec/layout/structure.html#structure-app-bar), formerly known as the action bar in Android,\nis a special kind of toolbar that’s used for branding, navigation, search, and actions.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/AppBar/README.md
 ** module id = 932
 ** module chunks = 0
 **/